var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"section-label",style:(_vm.order > 1 && 'padding-top: 20px')},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }